<template>
  <div :class="$b()">
    <div :class="$b('image', { hide: !showHiRes })">
      <slot
        name="hires"
        :loaded-handler="loadedHandler"
      />
    </div>
    <div :class="$b('image', { hide: showHiRes })">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HiResLazy',
  data() {
    return {
      showHiRes: false,
    }
  },
  methods: {
    loadedHandler() {
      this.showHiRes = true
    },
  },
}
</script>

<style lang="postcss">
.HiResLazy {
  @apply h-full relative;
}

.HiResLazy__image {
  @apply h-full w-full absolute inset-0;

  &&--hide {
    @apply hidden;
  }
}
</style>
